<div class="conditions-wrapper">
  <div class="condition-header-wrapper">
    <div class="caption">Order conditions (optional)</div>
    <div class="sub-caption">Apply this package only if the order meets certain rules</div>
  </div>
  @for (conditionsGroup of rulesArray.controls; track conditionsGroup; let conditionsIndex = $index) {
    <div [formGroup]="conditionsGroup">
      <div class="tag-wrapper">
        @if (conditionsIndex > 0) {
          <pdq-tag value="Or" size="large" variant="default" mode="rounded" padding="true"></pdq-tag>
        }
      </div>
      <div class="conditions">
        @if (isShowInfoDivOfCondition(conditionsIndex)) {
          <div class="condition-tag-div">
            <p class="condition-tag-text">Mapping engine</p>
          </div>
        }
        @for (conditionGroup of getRulesControls(conditionsIndex); track conditionGroup; let conditionIndex = $index) {
          <div [formGroup]="conditionGroup" class="condition-group-wrapper">
            <div class="condition-wrapper">
              <div class="list-wrapper">
                <pdq-dropdown
                  class="subject"
                  variant="static"
                  [options]="settingsEditPackageService.entityOptions"
                  (onChange)="entityChanged($event, conditionGroup, conditionsGroup)"
                  width="216"
                  placeholder="Choose"
                  [defaultOption]="
                    conditionGroup.controls.filterEntity.value
                      ? {
                          label: getFilterEntityLabelByValue(conditionGroup.controls.filterEntity.value),
                          value: conditionGroup.controls.filterEntity.value,
                        }
                      : null
                  ">
                </pdq-dropdown>
              </div>
              <div class="list-wrapper condion-list">
                <pdq-dropdown
                  class="condition"
                  variant="static"
                  [options]="
                    settingsEditPackageService.optionsByEntity[
                      this.settingsEditPackageService.formGroup.controls.rulesArray.controls[conditionsIndex].controls[
                        conditionIndex
                      ].controls.filterEntity.value
                    ]
                  "
                  width="216"
                  (onChange)="conditionChanged($event, conditionGroup, conditionsIndex)"
                  placeholder="Choose"
                  [defaultOption]="
                    conditionGroup.controls.conditionEntity.value
                      ? {
                          label: getConditionEntityLabelByValue(conditionGroup),
                          value: conditionGroup.controls.conditionEntity.value,
                        }
                      : null
                  ">
                </pdq-dropdown>
              </div>
              <div class="input-value-wrapper">
                @if (!conditionGroup.controls.conditionEntity.value) {
                  <pdq-input class="value-param" placeholder="value" width="216" disabled="true"></pdq-input>
                } @else {
                  @for (
                    param of settingsEditPackageService.getParamsBySelectedCondition(conditionGroup);
                    track param;
                    let i = $index
                  ) {
                    <div>
                      <div class="value-param">
                        @switch (param.fieldType) {
                          @case (inputType.INTEGER) {
                            <div>
                              @if (
                                conditionGroup.controls.filterEntity.value === rulesFilterEntity.SKU ||
                                conditionGroup.controls.filterEntity.value === rulesFilterEntity.PRODUCT_TYPE
                              ) {
                                <div class="integrer-wrapper">
                                  <span class="sku-content">quantity is</span>
                                  <pdq-input-arrows
                                    placeholder="no limit"
                                    min="0"
                                    [required]="false"
                                    [formControlName]="'param' + (i + 1)"
                                    widthSize="large"
                                    variant="form">
                                  </pdq-input-arrows>
                                </div>
                              } @else {
                                <pdq-input-arrows
                                  min="0"
                                  precision="3"
                                  [formControlName]="'param' + (i + 1)"
                                  variant="form">
                                </pdq-input-arrows>
                              }
                            </div>
                          }
                          @case (inputType.WEIGHT_UNIT) {
                            <pdq-dropdown
                              [options]="settingsEditPackageService.weightList"
                              (onChange)="
                                conditionGroup.controls['param' + (i + 1)].setValue($event.value);
                                conditionGroup.controls['param' + (i + 1)].markAsDirty()
                              "
                              [defaultOption]="{
                                label: conditionGroup.controls['param' + (i + 1)].value,
                                value: conditionGroup.controls['param' + (i + 1)].value,
                              }">
                            </pdq-dropdown>
                          }
                          @case (inputType.STRING) {
                            <div>
                              <div>
                                @switch (param.fieldSubType) {
                                  @case (fieldSubType.autocomplete) {
                                    <div class="autocomplete-wrapper">
                                      <div class="autocomplete-multi-select-wrapper">
                                        <div class="tags-container__list-options">
                                          @if (conditionGroup.controls['param' + (i + 1)].value?.length) {
                                            @for (
                                              selectedTag of conditionGroup.controls['param' + (i + 1)].value;
                                              track selectedTag;
                                              let tagIndex = $index
                                            ) {
                                              <pdq-chip
                                                #chipRef
                                                [maxWidth]="maximumAutocompleteWidth"
                                                [label]="selectedTag"
                                                (onChange)="onTagRemove(conditionsIndex, conditionIndex, tagIndex)">
                                              </pdq-chip>
                                            }
                                          }
                                        </div>
                                        <pdq-input
                                          formControlName="stringParam"
                                          placeholder=" "
                                          [autofocus]="true"
                                          [autocompleteMode]="true"
                                          [autocompleteRef]="pdqAutocomplete"
                                          [background]="'transparent'"
                                          [autoCompleteWidth]="419"
                                          [autoCompleteHeight]="112"
                                          [offsetPositionX]="-100"
                                          [border]="false">
                                        </pdq-input>
                                        <pdq-autocomplete #pdqAutocomplete="pdqAutocomplete" [mode]="'tags'">
                                          <ng-template pdqAutocompleteContent>
                                            @if (isLoadingResults) {
                                              <ng-container class="is-loading">
                                                <pdq-spinner></pdq-spinner>
                                              </ng-container>
                                            }
                                            @if (!isLoadingResults) {
                                              @for (
                                                tag of autocompleteList[conditionGroup.controls.filterEntity.value]
                                                  | filterStringResults
                                                    : getControlValue(conditionsIndex, conditionIndex);
                                                track tag
                                              ) {
                                                <pdq-options
                                                  (click)="onTagSelect(conditionsIndex, conditionIndex, tag)"
                                                  [value]="tag">
                                                  <pdq-tag
                                                    #tagRef
                                                    [matTooltip]="isTextOverflowed(tagRef) ? '' : tag"
                                                    [matTooltipClass]="'tags-filter__tooltip'"
                                                    [maxWidth]="maximumAutocompleteWidth"
                                                    >{{ tag }}
                                                  </pdq-tag>
                                                </pdq-options>
                                              }
                                              @if (
                                                isNoResults(
                                                  autocompleteList[conditionGroup.controls.filterEntity.value],
                                                  conditionsIndex,
                                                  conditionIndex
                                                )
                                              ) {
                                                <div class="no-results-found">
                                                  <span class="no-results-found__title"
                                                    >No results for "{{
                                                      getControlValue(conditionsIndex, conditionIndex)
                                                    }}"</span
                                                  >
                                                  <span class="no-results-found__subtitle"
                                                    >Maybe try something else?</span
                                                  >
                                                </div>
                                              }
                                            }
                                          </ng-template>
                                        </pdq-autocomplete>
                                      </div>
                                    </div>
                                  }
                                  @case (fieldSubType.freeText) {
                                    <div>
                                      <pdq-input
                                        [formControlName]="'param' + (i + 1)"
                                        placeholder="value"
                                        [background]="'default'">
                                      </pdq-input>
                                    </div>
                                  }
                                  @case (fieldSubType.list) {
                                    <div>
                                      <pdq-dropdown
                                        class="package-condition-value-dropdown"
                                        variant="static"
                                        [options]="param.options"
                                        (onChange)="
                                          conditionGroup.controls['param' + (i + 1)].setValue($event.value);
                                          conditionGroup.controls['param' + (i + 1)].markAsDirty()
                                        "
                                        width="216"
                                        placeholder="Choose"
                                        [defaultOption]="
                                          findDefaultOption(
                                            conditionGroup.controls['param' + (i + 1)].value,
                                            param?.options,
                                            InputType.STRING
                                          )
                                        ">
                                      </pdq-dropdown>
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          }
                          @case (inputType.JSON) {
                            <div>
                              <div>
                                @switch (param.fieldSubType) {
                                  @case (fieldSubType.list) {
                                    <div>
                                      <pdq-dropdown
                                        class="package-condition-value-dropdown"
                                        variant="static"
                                        [options]="param.options"
                                        (onChange)="
                                          conditionGroup.controls['param' + (i + 1)].setValue($event);
                                          conditionGroup.controls['param' + (i + 1)].markAsDirty()
                                        "
                                        width="216"
                                        placeholder="Choose"
                                        [defaultOption]="
                                          findDefaultOption(
                                            conditionGroup.controls['param' + (i + 1)].value,
                                            param?.options,
                                            InputType.JSON
                                          )
                                        ">
                                      </pdq-dropdown>
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                }
              </div>
              <pdq-icon
                class="close"
                icon="small_close"
                size="22"
                (click)="deleteCondition(conditionsIndex, conditionIndex)">
              </pdq-icon>
            </div>
            <div>
              @if (
                settingsEditPackageService.showFormErrors &&
                (!conditionGroup.get('filterEntity').valid ||
                  !conditionGroup.get('conditionEntity').valid ||
                  !conditionGroup.get('param1').valid)
              ) {
                <mat-error class="mat-error-text">
                  {{ settingsEditPackageService.getConditionError(conditionGroup, conditionIndex) }}
                </mat-error>
              }
            </div>
          </div>
        }
        <div class="add-condition" (click)="addCondition(conditionsIndex)">+And</div>
      </div>
    </div>
  }
  <div class="add-conditions">
    <pdq-button
      size="medium"
      label="+Or"
      [disabled]="false"
      variant="light"
      [loading]="false"
      (onClick)="addConditions()"></pdq-button>
  </div>
</div>
